import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const woodpeckerCi = defineConnector({
  identifier: "woodpeckerCi",
  name: "Woodpecker CI",
  tagLine: "Continuous integration engine",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.woodpecker-ci\\.org/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Woodpecker CI instance at **/user** and create a new personal token.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Woodpecker host",
          placeholder: "ci.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Personal token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/user`,
  },
});
